import styled from 'styled-components';

export const ErrorWrapper = styled.div`
  height: 25px;
  display: flex;
  align-items: center;
  color: darkred;
  margin-left: 10px;
  margin-bottom: 10px;
`;

export const InputWrapper = styled.div`
  height: 30px;
  margin: 5px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const Label = styled.label`
  height: 30px;
  margin-top: 20px;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 20px;
`;
